import {
    BellIcon,
    ChatAltIcon,
    ChevronRightIcon, CogIcon, FingerPrintIcon, HeroGlobeEuropeIcon, HeroWindowIcon, KeyIcon,
} from 'components/Icon/Icon'

import {
    ItemDisplayType, NestedDefaultMenuBarProps,
} from './types'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'

import React from 'react'

import {chevronWrapper} from '../styles/Menubar'
import {navigation} from 'navigation'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledChevronWrapper = styled('div', chevronWrapper)

export const DefaultMenuBarSettings = (props: NestedDefaultMenuBarProps<'Settings'>) => {
    const {
        params, type = ItemDisplayType.all,
    } = props

    const {t} = useTranslation()

    const showSettingsAccount = params?.tab === 'account'
    const showSettingsNotifications = params?.tab === 'notifications'
    const showSettingsInterface = params?.tab === 'user-interface'
    const showSettingsLanguage = params?.tab === 'language'
    const showSettingsCannedMessages = params?.tab === 'canned-messages'
    const showSettingsMasterKeys = params?.tab === 'master-keys'

    return (
        <>
            {/* eslint-disable-next-line no-extra-parens */}
            {(type === ItemDisplayType.middleItems && (params?.tab)) || type === ItemDisplayType.all || (type === ItemDisplayType.lastItem && !params?.tab) ?
                <>
                    {type !== ItemDisplayType.middleItems && <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>}
                    <Button
                        color='text'
                        iconLeft={CogIcon}
                        onPress={() => navigation.push('Settings')}
                        text={t('Settings and profile')}
                    />
                </>
                : null}
            {type === ItemDisplayType.lastItem || type === ItemDisplayType.all ?
                <>
                    {
                        showSettingsAccount ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={KeyIcon}
                                    onPress={() => navigation.push('Settings', {tab: 'account'})}
                                    text={t('Account & password')}
                                />
                            </>
                            : null
                    }
                    {
                        showSettingsNotifications ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={BellIcon}
                                    onPress={() => navigation.push('Settings', {tab: 'notifications'})}
                                    text={t('Notifications')}
                                />
                            </>
                            : null
                    }
                    {
                        showSettingsInterface ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroWindowIcon as unknown as Icon}
                                    onPress={() => navigation.push('Settings', {tab: 'user-interface'})}
                                    text={t('User interface')}
                                />
                            </>
                            : null
                    }
                    {
                        showSettingsLanguage ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroGlobeEuropeIcon as unknown as Icon}
                                    onPress={() => navigation.push('Settings', {tab: 'language'})}
                                    text={t('Language and region')}

                                />
                            </>
                            : null
                    }
                    {
                        showSettingsCannedMessages ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={ChatAltIcon}
                                    onPress={() => navigation.push('Settings', {tab: 'canned-messages'})}
                                    text={t('Canned messages')}

                                />
                            </>
                            : null
                    }
                    {
                        showSettingsMasterKeys ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={FingerPrintIcon}
                                    onPress={() => navigation.push('Settings', {tab: 'master-keys'})}
                                    text={t('Master keys')}

                                />
                            </>
                            : null
                    }
                </>
                : null}
        </>
    )
}
